<template>
  <div class="flex-grow">
    <h2 class="text-black md:text-4xl leading-9 md:mt-4 -mt-2 text-bold text-center">{{time}}</h2>
  </div>
</template>

<script>
export default {
  data() {
    return {
      time: "loading...",
    };
  },
  methods: {
    updateClock() {
      this.time = this.$moment().format("YYYY-MMM-DD HH:mm:ss");
    },
  },
  created() {
    setInterval(() => {
      this.updateClock();
    }, 1000);
  },
};
</script>

<style>
</style>